import actionTypes from "../actionTypes";
import {IConnections, IDataPartner} from "../../types";

const update = require('immutability-helper');


export const initialState = {
    dataPartner: {} as IDataPartner,
    connections: {} as IConnections,
    lastConnections: {} as Record<string, string>,
    userSelectedIndex: null as number | null,
    filtrosActualizados: true as boolean,
    filtroTexto: "" as string,
    filtroTipos: [] as number[],
    filtroParcelas: [] as number[],
    filtroSuperficie: [] as number[],
    filtroCultivos: [] as string[],
    filtroEstado: [] as number[],
    filtroCreacionInicio: null as Date | null,
    filtroCreacionFin: null as Date | null,
    filtroExpedicionInicio: null as Date | null,
    filtroExpedicionFin: null as Date | null,
    filtroUltimaConexionInicio: null as Date | null,
    filtroUltimaConexionFin: null as Date | null
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'set-data-partner':
            return update(state, {dataPartner: {$set: action.data}});

        case 'set-connections':
            return update(state, {connections: {$set: action.data}});

        case 'set-last-connections':
            return update(state, {lastConnections: {$set: action.data}});

        case 'set-user-selected-index':
            return update(state, {userSelectedIndex: {$set: action.index}});

        case 'set-filtros-actualizados':
            return update(state, {filtrosActualizados: {$set: action.actualizado}});

        case 'set-filtro-texto':
            return update(state, {filtroTexto: {$set: action.text}});

        case 'set-filtro-tipos':
            return update(state, {filtroTipos: {$set: action.tipos}});

        case 'set-filtro-parcelas':
            return update(state, {filtroParcelas: {$set: action.parcelas}});

        case 'set-filtro-superficie':
            return update(state, {filtroSuperficie: {$set: action.superficie}});

        case 'set-filtro-cultivos':
            return update(state, {filtroCultivos: {$set: action.cultivos}});

        case 'set-filtro-estado':
            return update(state, {filtroEstado: {$set: action.estado}});

        case 'set-filtro-creacion-inicio':
            return update(state, {filtroCreacionInicio: {$set: action.fecha}});

        case 'set-filtro-creacion-fin':
            return update(state, {filtroCreacionFin: {$set: action.fecha}});

        case 'set-filtro-expedicion-inicio':
            return update(state, {filtroExpedicionInicio: {$set: action.fecha}});

        case 'set-filtro-expedicion-fin':
            return update(state, {filtroExpedicionFin: {$set: action.fecha}});

        case 'set-filtro-ultima-conexion-inicio':
            return update(state, {filtroUltimaConexionInicio: {$set: action.fecha}});

        case 'set-filtro-ultima-conexion-fin':
            return update(state, {filtroUltimaConexionFin: {$set: action.fecha}});

        default:
            return state
    }
}
